"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSContactInformationComponent = void 0;
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
class CSHSContactInformationComponent {
    constructor(accountDetailService, accountService) {
        this.accountDetailService = accountDetailService;
        this.accountService = accountService;
        this.isSecondary = false;
        this.isProspect = false;
    }
    ngOnInit() {
        this.getAccountInformationDetails();
        this.showForm = true;
        this.getErrorMessage();
    }
    getAccountInformationDetails() {
        this.accountDetailService.getAccountContactInformation().subscribe((info) => {
            this.contactInfo = info;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
        this.accountService.getAccountDetails().subscribe((res) => {
            this.mdnList = res.subscription;
            this.isProspect = res.prospectProfile;
            if (res.profileType === 'SECONDARY') {
                this.isSecondary = true;
            }
        });
    }
    submitContactInformation(value) {
        this.loader = true;
        this.accountDetailService.validateContactInformation(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.getAccountInformationDetails();
            this.showForm = true;
            this.error = null;
            // if (res.error !== undefined) {
            //    // this.errorMsg = res.error;
            // } else {
            // }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    updateUserIdInformation(value) {
        this.loader = true;
        this.accountDetailService.submitUserIdInfo(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.getAccountInformationDetails();
            this.showUserIdForm = false;
            this.error = null;
            // this.showForm = true;
            // if (res.error !== undefined) {
            //    // this.errorMsg = res.error;
            // } else {
            // }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    convertPasswordToText() {
        this.showPasswords = !this.showPasswords;
        const element = document.getElementsByClassName('resetPassword');
        for (let i = 0; i < element.length; i++) {
            if (this.showPasswords) {
                element[i].type = 'text';
            }
            else {
                element[i].type = 'password';
            }
        }
        return this.showPasswords ? 'text' : 'password';
    }
    togglePassword() {
        const textIcon = '/resources/images/mmx-icon-eye-closed.png';
        const passIcon = '/resources/images/mmx-icon-eye-open.png';
        const logo = document.getElementsByClassName('input_img')[0];
        const currentPasswordType = this.convertPasswordToText();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        currentPasswordType === 'text' ? logo.src = textIcon : logo.src = passIcon;
    }
    checkButtonStatus() {
        if (this.accountPassword && this.accountConfirmPassword) {
            return this.accountPassword.trim() !== this.accountConfirmPassword.trim();
        }
        return true;
    }
}
exports.CSHSContactInformationComponent = CSHSContactInformationComponent;
//# sourceMappingURL=hscontactinformation.component.js.map